<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import { HorecaPath, GravyPath, ImagesPath } from "../../../../path";

export default {
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      cdn: process.env.VUE_APP_AWS_CDN,
      title: "Horeca Management",
      items: [
        { text: "Inventory" },
        { text: "Horeca Management", active: true },
      ],
      categories: [],
      allGravies: [],
      selectedGravyId: null,
      selectedGravyName: "",
      stagingCategoryIds: [],
      
      // Category Modal
      editCategory: {
        id: null,
        name: "",
        image_url: "",
        priority: 0,
        is_active: true,
      },
      
      // Table Fields
      categoryFields: [
        { key: "id", label: "ID", sortable: true, thClass: 'text-dark font-weight-bold', tdClass: 'text-dark' },
        { key: "image_url", label: "Image", thClass: 'text-dark font-weight-bold', tdClass: 'text-dark' },
        { key: "name", label: "Name", sortable: true, thClass: 'text-dark font-weight-bold', tdClass: 'text-dark' },
        { key: "priority", label: "Priority", sortable: true, thClass: 'text-dark font-weight-bold', tdClass: 'text-dark' },
        { key: "is_active", label: "Status", thClass: 'text-dark font-weight-bold', tdClass: 'text-dark' },
        { key: "actions", label: "Actions", thClass: 'text-dark font-weight-bold', tdClass: 'text-dark' },
      ],
      
      gravyTableFields: [
        { key: "id", label: "ID", sortable: true, thClass: 'text-dark font-weight-bold', tdClass: 'text-dark' },
        { key: "name", label: "Gravy Name", sortable: true, thClass: 'text-dark font-weight-bold', tdClass: 'text-dark' },
        { key: "food_type", label: "Type", thClass: 'text-dark font-weight-bold', tdClass: 'text-dark' },
        { key: "mapped_categories", label: "Mapped Categories", thClass: 'text-dark font-weight-bold', tdClass: 'text-dark' },
        { key: "actions", label: "Actions", thClass: 'text-dark font-weight-bold', tdClass: 'text-dark' },
      ],
      
      mappingFields: [
        { key: "name", label: "Category Name", sortable: true, thClass: 'text-dark font-weight-bold', tdClass: 'text-dark' },
        { key: "actions", label: "Action", thClass: 'text-dark font-weight-bold', tdClass: 'text-dark' },
      ],
      
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      categorySearch: "",
      gravySearch: "",
      mappingSearch: "",
      homeBannerSearch: "",
      horecaBannerSearch: "",
      bannerLockedSection: null,
      isLoading: false,
      
      activeHomeBannerIndex: 0,
      activeHorecaBannerIndex: 0,
      homeBannerTimer: null,
      horecaBannerTimer: null,
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
      
      banners: [],
      
      editBanner: {
        id: null,
        image_url: "",
        section: "home_top",
        action_type: "",
        action_target: null,
        action_value: null,
        priority: 0,
        is_active: true,
      },
      
      bannerFields: [
        { key: "id", label: "ID", sortable: true, thClass: 'text-dark font-weight-bold', tdClass: 'text-dark' },
        { key: "image_url", label: "Image", thClass: 'text-dark font-weight-bold', tdClass: 'text-dark' },
        { key: "section", label: "Section", sortable: true, thClass: 'text-dark font-weight-bold', tdClass: 'text-dark' },
        { key: "action", label: "Action Mapping", thClass: 'text-dark font-weight-bold', tdClass: 'text-dark' },
        { key: "priority", label: "Priority", sortable: true, thClass: 'text-dark font-weight-bold', tdClass: 'text-dark' },
        { key: "is_active", label: "Status", thClass: 'text-dark font-weight-bold', tdClass: 'text-dark' },
        { key: "actions", label: "Actions", thClass: 'text-dark font-weight-bold', tdClass: 'text-dark' },
      ],
      
      // Pagination configuration
      gravyCurrentPage: 1,
      gravyTotalRows: 0,
      gravyPerPage: 10,

    };
  },
  watch: {
    gravyCurrentPage() {
      this.fetchAllGravies();
    }
  },
  computed: {
    filteredCategoriesForMapping() {
      if (!this.mappingSearch) return this.categories;
      return this.categories.filter(c => 
        c.name.toLowerCase().includes(this.mappingSearch.toLowerCase())
      );
    },
    filteredHomeBanners() {
      return this.banners.filter(b => {
        if (b.section !== 'home_top') return false;
        if (!this.homeBannerSearch) return true;
        return (b.action_type || "").toLowerCase().includes(this.homeBannerSearch.toLowerCase());
      });
    },
    filteredHorecaBanners() {
      return this.banners.filter(b => {
        if (b.section !== 'horeca_main') return false;
        if (!this.horecaBannerSearch) return true;
        return (b.action_type || "").toLowerCase().includes(this.horecaBannerSearch.toLowerCase());
      });
    },
    activeBanners() {
      return this.banners.filter(b => (b.is_active == 1 || b.is_active === true) && b.section === 'home_top')
                 .sort((a,b) => a.priority - b.priority);
    },
    activeHorecaBanners() {
      return this.banners.filter(b => (b.is_active == 1 || b.is_active === true) && b.section === 'horeca_main')
                 .sort((a,b) => a.priority - b.priority);
    }
  },
  methods: {
    async fetchCategories() {
      this.isLoading = true;
      try {
        const response = await axios.get(this.base_url + HorecaPath.ALL_CATEGORIES);
        if (response.data.status) {
          const data = response.data.data;
          this.categories = Array.isArray(data) ? data : (data.data || []);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchAllGravies() {
      this.isLoading = true;
      try {
        const response = await axios.get(this.base_url + GravyPath.ALL, {
          // Send page param as per standard Laravel pagination
          params: { page: this.gravyCurrentPage, limit: this.gravyPerPage, search: this.gravySearch }
        });
        if (response.data.status) {
          const payload = response.data.data;
          
          if (payload && payload.data) {
             // It's a paginated object
             this.allGravies = payload.data;
             this.gravyTotalRows = payload.total;
             this.gravyPerPage = payload.per_page;
             this.gravyCurrentPage = payload.current_page;
          } else {
             // Fallback if not paginated
             this.allGravies = Array.isArray(payload) ? payload : [];
             this.gravyTotalRows = this.allGravies.length;
          }
        }
      } catch (error) {
        console.error("Error fetching gravies:", error);
      } finally {
        this.isLoading = false;
      }
    },
    gravySearchTrigger() {
       // Reset to page 1 on search
       this.gravyCurrentPage = 1;
       this.fetchAllGravies();
    },
    openCategoryModal(category = null) {
      if (category) {
        this.editCategory = {
           ...category,
           is_active: category.is_active == 1 || category.is_active === true
        };
      } else {
        this.editCategory = {
          id: null,
          name: "",
          image_url: "",
          priority: 0,
          is_active: true,
        };
      }
      this.$bvModal.show("category-modal");
    },
    async uploadCategoryImage(e) {
      try {
        let formData = new FormData();
        formData.append('file', e.target.files[0]);
        formData.append('folder', 'categories');
        let res = await axios.post(this.base_url + ImagesPath.UPLOAD_IMAGE, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if (res.data.status) {
          // Construct the full image URL if the backend returns a relative path
          // If the backend returns a full URL, just use it directly
          this.editCategory.image_url = this.cdn + '/' + res.data.data.file;
        }
      } catch (err) {
        console.error("Error uploading image:", err);
        this.$bvToast.toast("Error uploading image", { 
          title: "Error",
          variant: "danger",
          solid: true
        });
      }
    },
    async saveCategory() {
      try {
        const priority = parseInt(this.editCategory.priority);
        const conflict = this.categories.find(c =>
          parseInt(c.priority) === priority && c.id !== this.editCategory.id
        );

        if (conflict) {
          const changeOther = await this.$bvModal.msgBoxConfirm(
            `Priority ${priority} is already assigned to "${conflict.name}". What would you like to do?`,
            {
              title: 'Duplicate Priority',
              okTitle: `Reassign "${conflict.name}" to next available`,
              cancelTitle: 'Edit My Priority',
              headerBgVariant: 'light',
              okVariant: 'primary',
              cancelVariant: 'light',
              centered: true,
            }
          );
          if (!changeOther) return;

          const maxPriority = Math.max(...this.categories.map(c => parseInt(c.priority) || 0));
          await axios.post(this.base_url + HorecaPath.SAVE_CATEGORY, {
            ...conflict,
            priority: maxPriority + 1,
            is_active: (conflict.is_active == 1 || conflict.is_active === true) ? 1 : 0,
          });
        }

        const payload = {
           ...this.editCategory,
           is_active: this.editCategory.is_active ? 1 : 0
        };
        const response = await axios.post(this.base_url + HorecaPath.SAVE_CATEGORY, payload);
        if (response.data.status) {
          this.$bvToast.toast("Category saved successfully", {
            title: "Success",
            variant: "success",
            solid: true
          });
          this.$bvModal.hide("category-modal");
          this.fetchCategories();
        }
      } catch (error) {
        this.$bvToast.toast("Error saving category", {
          title: "Error",
          variant: "danger",
          solid: true
        });
      }
    },
    async deleteCategory(id) {
      if (!confirm("Are you sure you want to delete this category?")) return;
      try {
        const response = await axios.delete(`${this.base_url}${HorecaPath.DELETE_CATEGORY}/${id}`);
        if (response.data.status) {
          this.$bvToast.toast("Category deleted successfully", { 
            title: "Success",
            variant: "success",
            solid: true
          });
          this.fetchCategories();
        }
      } catch (error) {
        this.$bvToast.toast("Error deleting category", { 
          title: "Error",
          variant: "danger",
          solid: true
        });
      }
    },
    selectForMapping(gravy) {
      this.selectedGravyId = gravy.id;
      this.selectedGravyName = gravy.name;
      this.mappingSearch = "";
      
      // Initialize staging categories based on current API state
      let currentCategoryIds = [];
      if (gravy && gravy.horeca_categories) {
         currentCategoryIds = gravy.horeca_categories.map(c => c.id);
      }
      this.stagingCategoryIds = [...currentCategoryIds];
      
      this.$bvModal.show("mapping-modal");
    },
    isMapped(categoryId) {
      return this.stagingCategoryIds.includes(categoryId);
    },
    toggleMapping(category) {
      const mapped = this.isMapped(category.id);
      
      if (mapped) {
         this.stagingCategoryIds = this.stagingCategoryIds.filter(id => id !== category.id);
      } else {
         this.stagingCategoryIds.push(category.id);
      }
    },
    async saveMapping() {
      const payload = {
        category_ids: this.stagingCategoryIds,
        gravy_id: this.selectedGravyId
      };
      
      try {
        const response = await axios.post(this.base_url + HorecaPath.MAP_GRAVY, payload);
        if (response.data.status) {
          this.$bvToast.toast("Mapping updated", { 
            title: "Success",
            variant: "success",
            solid: true
          });
          // Refresh the gravies to update the horeca_categories array
          await this.fetchAllGravies();
          this.$bvModal.hide('mapping-modal');
        }
      } catch (error) {
        this.$bvToast.toast("Error updating mapping", { 
          title: "Error",
          variant: "danger",
          solid: true
        });
      }
    },
    async fetchBanners() {
      try {
        const response = await axios.get(this.base_url + HorecaPath.ALL_BANNERS);
        if (response.data.status) {
          this.banners = Array.isArray(response.data.data) ? response.data.data : [];
        }
      } catch (error) {
        console.error("Error fetching banners:", error);
      }
    },
    openBannerModal(banner = null, section = null) {
      if (banner) {
        this.editBanner = {
           ...banner,
           is_active: banner.is_active == 1 || banner.is_active === true
        };
        this.bannerLockedSection = banner.section;
      } else {
        this.editBanner = {
          id: null,
          image_url: "",
          section: section || "home_top",
          action_type: "",
          action_target: null,
          action_value: null,
          priority: 0,
          is_active: true,
        };
        this.bannerLockedSection = section;
      }
      this.$bvModal.show("banner-modal");
    },
    async uploadBannerImage(e) {
      try {
        let formData = new FormData();
        formData.append('file', e.target.files[0]);
        formData.append('folder', 'banners');
        let res = await axios.post(this.base_url + ImagesPath.UPLOAD_IMAGE, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if (res.data.status) {
          this.editBanner.image_url = this.cdn + '/' + res.data.data.file;
        }
      } catch (err) {
        console.error("Error uploading banner image:", err);
        this.$bvToast.toast("Error uploading image", { 
          title: "Error",
          variant: "danger",
          solid: true
        });
      }
    },
    async saveBanner() {
      try {
        const priority = parseInt(this.editBanner.priority);
        const section = this.editBanner.section;
        const conflict = this.banners.find(b =>
          parseInt(b.priority) === priority &&
          b.section === section &&
          b.id !== this.editBanner.id
        );

        if (conflict) {
          const changeOther = await this.$bvModal.msgBoxConfirm(
            `Priority ${priority} in section "${section}" is already taken by another banner. What would you like to do?`,
            {
              title: 'Duplicate Priority',
              okTitle: 'Reassign conflicting banner to next available',
              cancelTitle: 'Edit My Priority',
              headerBgVariant: 'light',
              okVariant: 'primary',
              cancelVariant: 'light',
              centered: true,
            }
          );
          if (!changeOther) return;

          const sectionBanners = this.banners.filter(b => b.section === section);
          const maxPriority = Math.max(...sectionBanners.map(b => parseInt(b.priority) || 0));
          await axios.post(this.base_url + HorecaPath.SAVE_BANNER, {
            ...conflict,
            priority: maxPriority + 1,
            is_active: (conflict.is_active == 1 || conflict.is_active === true) ? 1 : 0,
          });
        }

        const payload = {
           ...this.editBanner,
           is_active: this.editBanner.is_active ? 1 : 0
        };
        const response = await axios.post(this.base_url + HorecaPath.SAVE_BANNER, payload);
        if (response.data.status) {
          this.$bvToast.toast("Banner saved successfully", {
            title: "Success",
            variant: "success",
            solid: true
          });
          this.$bvModal.hide("banner-modal");
          this.fetchBanners();
        }
      } catch (error) {
        this.$bvToast.toast("Error saving banner", {
          title: "Error",
          variant: "danger",
          solid: true
        });
      }
    },
    async deleteBanner(id) {
      if (!confirm("Are you sure you want to delete this banner?")) return;
      try {
        const response = await axios.delete(`${this.base_url}${HorecaPath.DELETE_BANNER}/${id}`);
        if (response.data.status) {
          this.$bvToast.toast("Banner deleted successfully", { 
            title: "Success",
            variant: "success",
            solid: true
          });
          this.fetchBanners();
        }
      } catch (error) {
        this.$bvToast.toast("Error deleting banner", { 
          title: "Error",
          variant: "danger",
          solid: true
        });
      }
    },
    startAutoScroll() {
      this.homeBannerTimer = setInterval(() => {
        this.autoScrollBanner('home');
      }, 5000); // Increased delay
      this.horecaBannerTimer = setInterval(() => {
        this.autoScrollBanner('horeca');
      }, 5500); // Increased delay
    },
    autoScrollBanner(type) {
      const isHome = type === 'home';
      const activeBanners = isHome ? this.activeBanners : this.activeHorecaBanners;
      
      if (activeBanners.length <= 1) return;

      const scroller = isHome ? this.$refs.homeScroll : this.$refs.horecaScroll;
      if (!scroller) return;

      let currentIndex = isHome ? this.activeHomeBannerIndex : this.activeHorecaBannerIndex;
      let nextIndex = (currentIndex + 1) % activeBanners.length;
      
      const scrollWidth = scroller.clientWidth;
      scroller.scrollTo({ left: nextIndex * scrollWidth, behavior: 'smooth' });
    },
    onScrollBanner(type, event) {
      if (this.isDragging) return;
      const scrollLeft = event.target.scrollLeft;
      const clientWidth = event.target.clientWidth;
      const index = Math.round(scrollLeft / clientWidth);
      
      if (type === 'home') this.activeHomeBannerIndex = index;
      else if (type === 'horeca') this.activeHorecaBannerIndex = index;
    },
    startDrag(e, type) {
      this.isDragging = true;
      const slider = type === 'home' ? this.$refs.homeScroll : this.$refs.horecaScroll;
      slider.style.scrollSnapType = 'none';
      slider.style.scrollBehavior = 'auto';
      slider.classList.add('dragging');
      this.startX = e.pageX - slider.offsetLeft;
      this.scrollLeft = slider.scrollLeft;
      
      if (type === 'home' && this.homeBannerTimer) clearInterval(this.homeBannerTimer);
      if (type === 'horeca' && this.horecaBannerTimer) clearInterval(this.horecaBannerTimer);
    },
    stopDrag(type) {
      if (!this.isDragging) return;
      this.isDragging = false;
      const slider = type === 'home' ? this.$refs.homeScroll : this.$refs.horecaScroll;
      slider.style.scrollSnapType = 'x mandatory'; 
      slider.style.scrollBehavior = 'smooth';
      slider.classList.remove('dragging');
      
      if (type === 'home') {
        this.homeBannerTimer = setInterval(() => { this.autoScrollBanner('home'); }, 5000);
      }
      if (type === 'horeca') {
        this.horecaBannerTimer = setInterval(() => { this.autoScrollBanner('horeca'); }, 5500);
      }
    },
    onActionTypeChange(value) {
      if (value === 'none') {
        this.editBanner.action_target = null;
        this.editBanner.action_value = null;
      }
    },
    onDrag(e, type) {
      if (!this.isDragging) return;
      e.preventDefault();
      const slider = type === 'home' ? this.$refs.homeScroll : this.$refs.horecaScroll;
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - this.startX) * 1.5;
      slider.scrollLeft = this.scrollLeft - walk;
    },
  },
  mounted() {
    this.fetchCategories();
    this.fetchAllGravies();
    this.fetchBanners();
    this.startAutoScroll();
  },
  beforeDestroy() {
    if (this.homeBannerTimer) clearInterval(this.homeBannerTimer);
    if (this.horecaBannerTimer) clearInterval(this.horecaBannerTimer);
  }
};
</script>

<template>
  <Layout>
    <div id="horeca-page-content">
      <PageHeader :title="title" :items="items" />
      
      <!-- Gravies Section -->
      <div class="row mb-5">
        <div class="col-12">
          <div class="card horeca-main-card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center mb-4 border-bottom pb-3">
                <h4 class="m-0 text-dark font-weight-bold">All Gravies</h4>
              </div>

              <!-- Search Row -->
              <div class="row mb-4">
                <div class="col-md-4">
                  <div class="search-box">
                    <label class="text-dark font-weight-bold mb-1">Search gravies...</label>
                    <b-form-input
                      v-model="gravySearch"
                      @input="gravySearchTrigger"
                      type="search"
                      class="form-control"
                      placeholder="Enter gravy name..."
                    ></b-form-input>
                  </div>
                </div>
              </div>

              <div class="table-responsive mb-0 mt-2">
                <b-table
                  :items="allGravies"
                  :fields="gravyTableFields"
                  responsive="sm"
                  hover
                  show-empty
                  class="bg-white"
                  thead-class="bg-light"
                >
                  <template v-slot:cell(food_type)="row">
                     <img src="@/assets/veg.png" style="width: 25px" v-if="row.item.food_type == 'veg'" />
                     <img src="@/assets/non_veg.png" style="width: 20px" v-else-if="row.item.food_type == 'non_veg'" />
                     <span class="ml-1 text-capitalize text-dark">{{ row.item.food_type }}</span>
                  </template>
                  
                  <template v-slot:cell(mapped_categories)="row">
                    <div v-if="row.item.horeca_categories && row.item.horeca_categories.length > 0">
                      <b-badge 
                        v-for="cat in row.item.horeca_categories" 
                        :key="cat.id"
                        variant="info" 
                        class="mr-1 mb-1 px-2 py-1 shadow-sm text-dark bg-info-subtle border border-info"
                      >
                        {{ cat.name }}
                      </b-badge>
                    </div>
                    <span v-else class="text-muted small">Not mapped</span>
                  </template>

                  <template v-slot:cell(actions)="row">
                    <div class="action-buttons">
                      <b-button size="sm" variant="primary" class="mr-1 shadow-sm px-3" @click="selectForMapping(row.item)" title="Map Categories">
                        <i class="fa fa-list mr-1"></i> Map Categories
                      </b-button>
                    </div>
                  </template>

                  <!-- Empty State -->
                  <template v-slot:empty="scope">
                    <div class="text-center p-4">
                      <h5 class="text-muted">{{ scope.emptyText }}</h5>
                    </div>
                  </template>
                </b-table>
              </div>
              
              <!-- Pagination -->
              <div class="row mt-4">
                <div class="col-sm-12 col-md-6 d-flex align-items-center">
                  <div class="dataTables_info text-dark" role="status" aria-live="polite">
                    Showing {{ (gravyCurrentPage - 1) * gravyPerPage + 1 }} to
                    {{ Math.min(gravyCurrentPage * gravyPerPage, gravyTotalRows) }} of
                    {{ gravyTotalRows }} entries
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 d-flex justify-content-end">
                  <b-pagination
                    v-model="gravyCurrentPage"
                    :total-rows="gravyTotalRows"
                    :per-page="gravyPerPage"
                    aria-controls="my-table"
                    class="mb-0"
                    align="right"
                    pills
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Categories Section -->
      <div class="row">
        <div class="col-12">
          <div class="card horeca-main-card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center mb-4 border-bottom pb-3">
                <h4 class="m-0 text-dark font-weight-bold">Horeca Categories & Mapping</h4>
                <b-button 
                  variant="primary" 
                  @click="openCategoryModal()" 
                  class="btn btn-primary px-4 shadow-sm"
                >
                  <i class="fa fa-plus mr-1"></i> Add Category
                </b-button>
              </div>

              <!-- Search Row -->
              <div class="row mb-4">
                <div class="col-md-4">
                  <div class="search-box">
                    <label class="text-dark font-weight-bold mb-1">Search categories...</label>
                    <b-form-input
                      v-model="categorySearch"
                      type="search"
                      class="form-control"
                      placeholder="Enter category name..."
                    ></b-form-input>
                  </div>
                </div>
              </div>

              <div class="table-responsive mb-0 mt-2">
                <b-table
                  :items="categories"
                  :fields="categoryFields"
                  :filter="categorySearch"
                  responsive="sm"
                  hover
                  show-empty
                  class="bg-white"
                  thead-class="bg-light"
                >
                  <!-- Custom Cell Templates -->
                  <template v-slot:cell(image_url)="row">
                    <img 
                      :src="row.item.image_url" 
                      alt="" 
                      style="width: 50px; height: 50px; object-fit: cover;" 
                      class="img-thumbnail border shadow-sm" 
                      v-if="row.item.image_url" 
                    />
                    <span v-else class="text-muted small">No Image</span>
                  </template>
                  
                  <template v-slot:cell(is_active)="row">
                    <b-badge :variant="row.item.is_active ? 'success' : 'danger'" class="px-2 py-1">
                      {{ row.item.is_active ? 'Active' : 'Inactive' }}
                    </b-badge>
                  </template>

                  <template v-slot:cell(actions)="row">
                    <div class="action-buttons">
                      <b-button size="sm" variant="primary" class="mr-1 shadow-sm" @click="openCategoryModal(row.item)" title="Edit">
                        <i class="fa fa-pen"></i>
                      </b-button>
                      <b-button size="sm" variant="danger" class="shadow-sm" @click="deleteCategory(row.item.id)" title="Delete">
                        <i class="fa fa-trash"></i>
                      </b-button>
                    </div>
                  </template>

                  <!-- Empty State -->
                  <template v-slot:empty="scope">
                    <div class="text-center p-4">
                      <h5 class="text-muted">{{ scope.emptyText }}</h5>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Home Top Banners -->
      <div class="row mb-5">
        <!-- Table (Left) -->
        <div class="col-xl-7 col-md-12 mb-4 mb-xl-0">
          <div class="card horeca-main-card h-100">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center mb-4 border-bottom pb-3">
                <div>
                  <h4 class="m-0 text-dark font-weight-bold">Home Top Banners</h4>
                  <small class="text-muted">Displayed on the main app home screen</small>
                </div>
                <b-button variant="primary" @click="openBannerModal(null, 'home_top')" class="btn btn-primary px-4 shadow-sm">
                  <i class="fa fa-plus mr-1"></i> Add Banner
                </b-button>
              </div>
              <div class="row mb-3">
                <div class="col-md-5">
                  <b-form-input v-model="homeBannerSearch" type="search" class="form-control" placeholder="Search by action type..."></b-form-input>
                </div>
              </div>
              <div class="table-responsive mb-0">
                <b-table :items="filteredHomeBanners" :fields="bannerFields" responsive="sm" hover show-empty class="bg-white" thead-class="bg-light">
                  <template v-slot:cell(image_url)="row">
                    <img :src="row.item.image_url" style="height: 50px; border-radius: 5px;" v-if="row.item.image_url" class="border shadow-sm"/>
                    <span v-else class="text-muted small">No Image</span>
                  </template>
                  <template v-slot:cell(section)="row">
                    <b-badge variant="light" class="border text-dark px-2 py-1">{{ row.item.section }}</b-badge>
                  </template>
                  <template v-slot:cell(action)="row">
                    <div class="small">
                      <div v-if="row.item.action_type && row.item.action_type !== 'none'">
                        <span class="font-weight-bold text-primary">{{ row.item.action_type }}</span>
                        <i class="fa fa-arrow-right mx-1 text-muted"></i>
                        <span v-if="row.item.action_target" class="text-dark">{{ row.item.action_target }}</span>
                        <span v-if="row.item.action_value" class="text-muted ml-1">({{ row.item.action_value }})</span>
                      </div>
                      <div v-else class="text-muted font-italic">No action</div>
                    </div>
                  </template>
                  <template v-slot:cell(is_active)="row">
                    <b-badge :variant="row.item.is_active ? 'success' : 'danger'" class="px-2 py-1">
                      {{ row.item.is_active ? 'Active' : 'Inactive' }}
                    </b-badge>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <div class="action-buttons">
                      <b-button size="sm" variant="primary" class="mr-1 shadow-sm px-2" @click="openBannerModal(row.item)" title="Edit Banner"><i class="fa fa-pen"></i></b-button>
                      <b-button size="sm" variant="danger" class="shadow-sm px-2" @click="deleteBanner(row.item.id)" title="Delete Banner"><i class="fa fa-trash"></i></b-button>
                    </div>
                  </template>
                  <template v-slot:empty="scope">
                    <div class="text-center p-4"><h5 class="text-muted">{{ scope.emptyText }}</h5></div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
        <!-- App Home Preview (Right) -->
        <div class="col-xl-5 col-md-12 d-flex justify-content-center">
          <div style="position: sticky; top: 20px;">
            <h6 class="text-dark font-weight-bold mb-3 text-center"><i class="fa fa-mobile-alt mr-2 text-muted"></i>App Home Preview</h6>
            <div class="mobile-mockup shadow-sm border rounded">
              <div class="mobile-screen-content">
                <div class="skeleton-app-header d-flex justify-content-between align-items-center px-3 py-2">
                  <div class="d-flex align-items-center">
                    <div class="skeleton-logo"></div>
                    <div class="ml-2">
                      <div class="skeleton-text skeleton-text-short"></div>
                      <div class="skeleton-text skeleton-text-long"></div>
                    </div>
                  </div>
                  <div class="skeleton-button"></div>
                </div>
                <div class="mobile-scrollable-area">
                  <div class="skeleton-notice-board">
                    <div class="skeleton-text mb-2"></div>
                    <div class="skeleton-text w-75"></div>
                  </div>
                  <div class="mobile-banner-scroll-wrapper">
                    <div class="mobile-banner-scroll" v-if="activeBanners.length > 0" ref="homeScroll"
                      @scroll.passive="onScrollBanner('home', $event)"
                      @mousedown.prevent="startDrag($event, 'home')"
                      @mouseleave="stopDrag('home')"
                      @mouseup="stopDrag('home')"
                      @mousemove="onDrag($event, 'home')"
                    >
                      <div class="mobile-banner-item" v-for="banner in activeBanners" :key="banner.id">
                        <img class="d-block img-fluid w-100 banner-img" :src="banner.image_url" alt="Banner">
                      </div>
                    </div>
                    <div class="mobile-banner-indicators" v-if="activeBanners.length > 1">
                      <div v-for="(banner, index) in activeBanners" :key="'ind-'+banner.id" :class="['indicator-dot', { active: index === activeHomeBannerIndex }]"></div>
                    </div>
                    <div v-if="activeBanners.length === 0" class="text-center text-muted p-4 border rounded bg-light mx-3 mb-3">
                      <i class="fa fa-image fa-2x mb-2 text-dark"></i>
                      <p class="m-0 small font-weight-bold">No Active Banners</p>
                    </div>
                  </div>
                  <div class="px-3 mt-4">
                    <div class="skeleton-title mb-3"></div>
                    <div class="row px-2">
                      <div class="col-6 p-1"><div class="skeleton-card"></div></div>
                      <div class="col-6 p-1"><div class="skeleton-card"></div></div>
                      <div class="col-6 p-1"><div class="skeleton-card"></div></div>
                      <div class="col-6 p-1"><div class="skeleton-card"></div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Horeca Main Banners -->
      <div class="row">
        <!-- Table (Left) -->
        <div class="col-xl-7 col-md-12 mb-4 mb-xl-0">
          <div class="card horeca-main-card h-100">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center mb-4 border-bottom pb-3">
                <div>
                  <h4 class="m-0 text-dark font-weight-bold">Horeca Banners</h4>
                  <small class="text-muted">Displayed on the Horeca order screen</small>
                </div>
                <b-button variant="primary" @click="openBannerModal(null, 'horeca_main')" class="btn btn-primary px-4 shadow-sm">
                  <i class="fa fa-plus mr-1"></i> Add Banner
                </b-button>
              </div>
              <div class="row mb-3">
                <div class="col-md-5">
                  <b-form-input v-model="horecaBannerSearch" type="search" class="form-control" placeholder="Search by action type..."></b-form-input>
                </div>
              </div>
              <div class="table-responsive mb-0">
                <b-table :items="filteredHorecaBanners" :fields="bannerFields" responsive="sm" hover show-empty class="bg-white" thead-class="bg-light">
                  <template v-slot:cell(image_url)="row">
                    <img :src="row.item.image_url" style="height: 50px; border-radius: 5px;" v-if="row.item.image_url" class="border shadow-sm"/>
                    <span v-else class="text-muted small">No Image</span>
                  </template>
                  <template v-slot:cell(section)="row">
                    <b-badge variant="light" class="border text-dark px-2 py-1">{{ row.item.section }}</b-badge>
                  </template>
                  <template v-slot:cell(action)="row">
                    <div class="small">
                      <div v-if="row.item.action_type && row.item.action_type !== 'none'">
                        <span class="font-weight-bold text-primary">{{ row.item.action_type }}</span>
                        <i class="fa fa-arrow-right mx-1 text-muted"></i>
                        <span v-if="row.item.action_target" class="text-dark">{{ row.item.action_target }}</span>
                        <span v-if="row.item.action_value" class="text-muted ml-1">({{ row.item.action_value }})</span>
                      </div>
                      <div v-else class="text-muted font-italic">No action</div>
                    </div>
                  </template>
                  <template v-slot:cell(is_active)="row">
                    <b-badge :variant="row.item.is_active ? 'success' : 'danger'" class="px-2 py-1">
                      {{ row.item.is_active ? 'Active' : 'Inactive' }}
                    </b-badge>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <div class="action-buttons">
                      <b-button size="sm" variant="primary" class="mr-1 shadow-sm px-2" @click="openBannerModal(row.item)" title="Edit Banner"><i class="fa fa-pen"></i></b-button>
                      <b-button size="sm" variant="danger" class="shadow-sm px-2" @click="deleteBanner(row.item.id)" title="Delete Banner"><i class="fa fa-trash"></i></b-button>
                    </div>
                  </template>
                  <template v-slot:empty="scope">
                    <div class="text-center p-4"><h5 class="text-muted">{{ scope.emptyText }}</h5></div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
        <!-- Horeca Home Preview (Right) -->
        <div class="col-xl-5 col-md-12 d-flex justify-content-center">
          <div style="position: sticky; top: 20px;">
            <h6 class="text-dark font-weight-bold mb-3 text-center"><i class="fa fa-mobile-alt mr-2 text-muted"></i>Horeca Home Preview</h6>
            <div class="mobile-mockup shadow-sm border rounded">
              <div class="mobile-screen-content">
                <div class="skeleton-app-header d-flex justify-content-between align-items-center px-3 py-2 text-white">
                  <div>
                    <h6 class="m-0 font-weight-bold">Order Gravies</h6>
                    <div class="small opacity-75 d-flex align-items-center mt-1">
                      <i class="fa fa-store mr-1" style="font-size: 10px;"></i> Restaurant partner
                    </div>
                  </div>
                  <div class="text-white"><i class="fa fa-history" style="font-size: 18px;"></i></div>
                </div>
                <div class="mobile-scrollable-area bg-white">
                  <div class="mobile-banner-scroll-wrapper">
                    <div class="mobile-banner-scroll" v-if="activeHorecaBanners.length > 0" ref="horecaScroll"
                      @scroll.passive="onScrollBanner('horeca', $event)"
                      @mousedown.prevent="startDrag($event, 'horeca')"
                      @mouseleave="stopDrag('horeca')"
                      @mouseup="stopDrag('horeca')"
                      @mousemove="onDrag($event, 'horeca')"
                    >
                      <div class="mobile-banner-item" v-for="banner in activeHorecaBanners" :key="banner.id">
                        <img class="d-block img-fluid w-100 banner-img" :src="banner.image_url" alt="Banner">
                      </div>
                    </div>
                    <div class="mobile-banner-indicators" v-if="activeHorecaBanners.length > 1">
                      <div v-for="(banner, index) in activeHorecaBanners" :key="'ind-h-'+banner.id" :class="['indicator-dot', { active: index === activeHorecaBannerIndex }]"></div>
                    </div>
                    <div v-if="activeHorecaBanners.length === 0" class="text-center text-muted p-4 border rounded bg-light mx-3 mb-3">
                      <i class="fa fa-image fa-2x mb-2 text-dark"></i>
                      <p class="m-0 small font-weight-bold">No Active Banners</p>
                    </div>
                  </div>
                  <div class="px-3 mt-4">
                    <h6 class="font-weight-bold mb-3 text-dark">Categories</h6>
                    <div class="row px-1">
                      <div class="col-4 p-1"><div class="skeleton-category-card"></div><div class="skeleton-text mx-auto mt-2" style="width: 80%;"></div></div>
                      <div class="col-4 p-1"><div class="skeleton-category-card"></div><div class="skeleton-text mx-auto mt-2" style="width: 60%;"></div></div>
                      <div class="col-4 p-1"><div class="skeleton-category-card"></div><div class="skeleton-text mx-auto mt-2" style="width: 90%;"></div></div>
                      <div class="col-4 p-1 mt-2"><div class="skeleton-category-card"></div><div class="skeleton-text mx-auto mt-2" style="width: 70%;"></div></div>
                      <div class="col-4 p-1 mt-2"><div class="skeleton-category-card"></div><div class="skeleton-text mx-auto mt-2" style="width: 85%;"></div></div>
                      <div class="col-4 p-1 mt-2"><div class="skeleton-category-card"></div><div class="skeleton-text mx-auto mt-2" style="width: 50%;"></div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modals (Outside the content div for better stacking) -->
    <b-modal id="category-modal" :title="editCategory.id ? 'Edit Category' : 'Add Category'" hide-footer header-bg-variant="light">
      <div class="p-3">
          <b-form @submit.prevent="saveCategory">
            <b-form-group label="Category Name" label-class="text-dark font-weight-bold">
              <b-form-input v-model="editCategory.name" required placeholder="Enter name" class="border-dark-subtle"></b-form-input>
            </b-form-group>

            <b-form-group label="Category Image" label-class="text-dark font-weight-bold">
              <b-form-file
                accept="image/*"
                placeholder="Choose an image or drop it here..."
                drop-placeholder="Drop image here..."
                @change="uploadCategoryImage"
                class="border-dark-subtle mb-2"
              ></b-form-file>
              <div v-if="editCategory.image_url" class="mt-3 text-center border p-2 rounded bg-light shadow-sm">
                <img :src="editCategory.image_url" class="img-fluid rounded" style="max-height: 150px" />
              </div>
            </b-form-group>

            <div class="row">
              <div class="col-md-6">
                <b-form-group label="Priority" label-class="text-dark font-weight-bold">
                  <b-form-input type="number" v-model="editCategory.priority" class="border-dark-subtle"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-6 d-flex align-items-center pt-3">
                 <b-form-checkbox v-model="editCategory.is_active" switch>
                   <span class="text-dark font-weight-bold">{{ editCategory.is_active ? 'Active' : 'Inactive' }}</span>
                 </b-form-checkbox>
              </div>
            </div>

            <div class="mt-4 text-right pt-3 border-top">
              <b-button variant="light" @click="$bvModal.hide('category-modal')" class="mr-2 border text-dark">Cancel</b-button>
              <b-button variant="primary" type="submit" class="px-4">Save Category</b-button>
            </div>
          </b-form>
      </div>
    </b-modal>

    <!-- Banner Add/Edit Modal -->
    <b-modal id="banner-modal" :title="editBanner.id ? 'Edit Banner' : 'Add Banner'" hide-footer header-bg-variant="light">
      <div class="p-3">
          <b-form @submit.prevent="saveBanner">
            <div class="row">
                <div class="col-md-6">
                  <b-form-group label="Section" label-class="text-dark font-weight-bold">
                    <b-form-input v-if="bannerLockedSection" :value="editBanner.section" disabled class="form-control border-dark-subtle bg-light"></b-form-input>
                    <b-form-select v-else v-model="editBanner.section" required class="form-control border-dark-subtle">
                      <b-form-select-option value="home_top">home_top</b-form-select-option>
                      <b-form-select-option value="horeca_main">horeca_main</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
               </div>
               <div class="col-md-6">
                  <b-form-group label="Action Type" label-class="text-dark font-weight-bold">
                    <b-form-select v-model="editBanner.action_type" class="form-control border-dark-subtle" @change="onActionTypeChange">
                      <b-form-select-option value="navigate">navigate</b-form-select-option>
                      <b-form-select-option value="none">none</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
               </div>
            </div>
            
            <div class="row">
               <div class="col-md-6">
                  <b-form-group label="Action Target" label-class="text-dark font-weight-bold">
                    <b-form-select v-model="editBanner.action_target" class="form-control border-dark-subtle" :disabled="editBanner.action_type === 'none'">
                      <b-form-select-option :value="null">none</b-form-select-option>
                      <b-form-select-option value="horeca_home">horeca_home</b-form-select-option>
                      <b-form-select-option value="category">category</b-form-select-option>
                      <!-- Backend replaces action_value with the outlet's personal survey link -->
                      <b-form-select-option value="nps_survey">nps_survey</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
               </div>
               <div class="col-md-6">
                  <b-form-group label="Action Value" label-class="text-dark font-weight-bold">
                    <b-form-input v-model="editBanner.action_value" placeholder="e.g. category ID or link" class="border-dark-subtle" :disabled="editBanner.action_type === 'none'"></b-form-input>
                  </b-form-group>
               </div>
            </div>

            <b-form-group label="Banner Image" label-class="text-dark font-weight-bold">
              <b-form-file
                accept="image/*"
                placeholder="Choose banner image..."
                drop-placeholder="Drop here..."
                @change="uploadBannerImage"
                class="border-dark-subtle mb-2"
              ></b-form-file>
              <div v-if="editBanner.image_url" class="mt-3 text-center border p-2 rounded bg-light shadow-sm">
                <img :src="editBanner.image_url" class="img-fluid rounded" style="max-height: 120px; object-fit: contain;" />
              </div>
            </b-form-group>

            <div class="row mt-3">
              <div class="col-md-6">
                <b-form-group label="Priority" label-class="text-dark font-weight-bold">
                  <b-form-input type="number" v-model="editBanner.priority" class="border-dark-subtle"></b-form-input>
                  <small class="text-muted">Lower number = shows first</small>
                </b-form-group>
              </div>
              <div class="col-md-6 d-flex align-items-center pt-2">
                 <b-form-checkbox v-model="editBanner.is_active" switch>
                   <span class="text-dark font-weight-bold ml-1">{{ editBanner.is_active ? 'Active' : 'Hidden' }}</span>
                 </b-form-checkbox>
              </div>
            </div>

            <div class="mt-4 text-right pt-3 border-top">
              <b-button variant="light" @click="$bvModal.hide('banner-modal')" class="mr-2 border text-dark">Cancel</b-button>
              <b-button variant="primary" type="submit" class="px-4">Save Banner</b-button>
            </div>
          </b-form>
      </div>
    </b-modal>

    <b-modal id="mapping-modal" :title="'Map Categories for: ' + selectedGravyName" size="md" hide-footer header-bg-variant="light">
      <div class="p-3">
          <div class="row mb-4">
            <div class="col-12">
               <div class="search-box">
                  <label class="text-dark font-weight-bold mb-1">Search Categories...</label>
                 <b-form-input
                    v-model="mappingSearch"
                    type="search"
                    class="form-control border-dark-subtle"
                    placeholder="Search categories..."
                  ></b-form-input>
               </div>
            </div>
          </div>
          
          <div class="table-responsive border rounded" style="max-height: 500px; overflow-y: auto;">
            <b-table
              :items="filteredCategoriesForMapping"
              :fields="mappingFields"
              responsive="sm"
              hover
              show-empty
              class="bg-white mb-0"
            >
              <template v-slot:cell(actions)="row">
                <b-button 
                  :variant="isMapped(row.item.id) ? 'danger' : 'success'" 
                  size="sm" 
                  @click="toggleMapping(row.item)"
                  class="px-3"
                >
                  <i :class="isMapped(row.item.id) ? 'fa fa-minus' : 'fa fa-plus'"></i>
                  {{ isMapped(row.item.id) ? 'Unmap' : 'Map' }}
                </b-button>
              </template>
            </b-table>
          </div>
          
          <div class="mt-4 text-right pt-3 border-top">
            <b-button variant="light" @click="$bvModal.hide('mapping-modal')" class="mr-2 border text-dark">Cancel</b-button>
            <b-button variant="primary" @click="saveMapping" class="px-5">Save Mapping</b-button>
          </div>
      </div>
    </b-modal>

  </Layout>
</template>

<style>
/* 
   FORCE VISIBILITY - GLOBAL OVERRIDES 
   Using a non-scoped style block to ensure these rules hit despite deep tree structures 
*/

#horeca-page-content h1, 
#horeca-page-content h2, 
#horeca-page-content h3, 
#horeca-page-content h4, 
#horeca-page-content h5, 
#horeca-page-content h6, 
#horeca-page-content p, 
#horeca-page-content span:not(.sr-only), 
#horeca-page-content label, 
#horeca-page-content input, 
#horeca-page-content .btn,
#horeca-page-content th, 
#horeca-page-content td {
  color: #000000 !important;
  opacity: 1 !important;
  visibility: visible !important;
}

/* Specific fix for glass-input leakage */
#horeca-page-content .form-control,
.modal-content .form-control {
  color: #000000 !important;
  background-color: #ffffff !important;
  border: 1px solid #ced4da !important;
}

#horeca-page-content .card {
    background-color: #ffffff !important;
    border: 1px solid #e0e0e0 !important;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1) !important;
}

#horeca-page-content thead th {
    background-color: #f1f3f5 !important;
    color: #000000 !important;
    border-bottom: 2px solid #dee2e6 !important;
    text-transform: none !important;
    letter-spacing: normal !important;
}

#horeca-page-content .text-muted {
    color: #6c757d !important;
}

/* Modal text Fixes */
.modal-content, .modal-title, .modal-body label {
    color: #000000 !important;
}

/* Ensure sr-only elements stay hidden despite global color rules */
#horeca-page-content .sr-only {
    display: none !important;
}

.horeca-main-card {
    min-height: 400px;
}

/* App Preview Panel Styles */
.mobile-mockup {
  width: 360px;
  height: 640px;
  margin: 0 auto;
  position: relative;
  background-color: #f8f9fa;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  border-radius: 8px;
}

.mobile-screen-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.mobile-scrollable-area {
  overflow-y: auto;
  flex: 1;
}

.skeleton-app-header {
  background-color: #ee2a40;
  height: 65px;
}

.skeleton-logo {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background-color: rgba(255,255,255,0.8);
}

.skeleton-text {
  height: 10px;
  background-color: #e9ecef;
  border-radius: 5px;
  margin-bottom: 5px;
}

.skeleton-text-short {
  width: 60px;
  background-color: rgba(255,255,255,0.9);
}
.skeleton-text-long {
  width: 100px;
  background-color: rgba(255,255,255,0.5);
}

.skeleton-button {
  width: 35px;
  height: 35px;
  border-radius: 8px;
  background-color: rgba(255,255,255,0.3);
}

.skeleton-notice-board {
  margin: 15px;
  border-radius: 12px;
  border: 1px solid #fecba1;
  background-color: #fff9f2;
  padding: 15px;
  height: 80px;
}

.skeleton-notice-board .skeleton-text {
  background-color: #e2c0a1;
}

.mobile-banner-scroll-wrapper {
  margin-top: 15px;
}

.mobile-banner-scroll {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  padding: 0 15px; 
  gap: 15px;
  scroll-behavior: smooth;
  cursor: grab;
}

.mobile-banner-scroll.dragging {
  cursor: grabbing;
}

.mobile-banner-scroll.dragging .banner-img {
  pointer-events: none;
}

.mobile-banner-scroll::-webkit-scrollbar {
  display: none;
}

.mobile-banner-item {
  flex: 0 0 calc(100%);
  scroll-snap-align: center;
}

.banner-img {
  height: 160px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 3px 6px rgba(0,0,0,0.1);
}

.mobile-banner-indicators {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 12px;
  margin-bottom: 5px;
  gap: 6px;
}

.indicator-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #d1d5db;
  transition: all 0.3s ease;
}

.indicator-dot.active {
  width: 16px;
  border-radius: 4px;
  background-color: #ee2a40;
}

.skeleton-title {
  width: 140px;
  height: 18px;
  background-color: #d1d5db;
  border-radius: 5px;
}

.skeleton-card {
  height: 110px;
  background-color: #ffffff;
  border-radius: 15px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 4px 6px rgba(0,0,0,0.02);
}

.skeleton-category-card {
  height: 90px;
  background-color: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #f1f3f5;
}

/* Scrollbar styling for horizontal list */
.card-body::-webkit-scrollbar {
  height: 6px;
}
.card-body::-webkit-scrollbar-track {
  background: transparent;
}
.card-body::-webkit-scrollbar-thumb {
  background-color: #dee2e6;
  border-radius: 10px;
}

/* Hide scrollbar for preview inner area */
.mobile-scrollable-area::-webkit-scrollbar {
  display: none;
}

</style>
